// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createActions } from 'redux-actions';

export const GET_ADDRESS_VALIDATION_DATA = 'GET_ADDRESS_VALIDATION_DATA';
export const GET_ADDRESS_VALIDATION_DATA_SUCCESS =
    'GET_ADDRESS_VALIDATION_DATA_SUCCESS';
export const RESET_ADDRESS_DATA = 'RESET_ADDRESS_DATA';

export const GET_WIC_ADDRESS_DATA = 'GET_WIC_ADDRESS_DATA';
export const GET_WIC_ADDRESS_DATA_SUCCESS = 'GET_WIC_ADDRESS_DATA_SUCCESS';
export const RESET_WIC_ADDRESS_DATA = 'RESET_WIC_ADDRESS_DATA';
export const RESET_WIC_ADDRESS_DATA_SUCCESS = 'RESET_WIC_ADDRESS_DATA_SUCCESS';

export const SAVE_WIC_SELECTED_ADDRESS_DATA = 'SAVE_WIC_SELECTED_ADDRESS_DATA';
export const SAVE_WIC_SELECTED_ADDRESS_DATA_SUCCESS =
    'SAVE_WIC_SELECTED_ADDRESS_DATA_SUCCESS';

export const {
    getAddressValidationData,
    getAddressValidationDataSuccess,
    resetAddressData,

    getWicAddressData,
    getWicAddressDataSuccess,
    resetWicAddressData,
    resetWicAddressDataSuccess,

    saveWicSelectedAddressData,
    saveWicSelectedAddressDataSuccess,
} = createActions(
    GET_ADDRESS_VALIDATION_DATA,
    GET_ADDRESS_VALIDATION_DATA_SUCCESS,
    RESET_ADDRESS_DATA,

    GET_WIC_ADDRESS_DATA,
    GET_WIC_ADDRESS_DATA_SUCCESS,
    RESET_WIC_ADDRESS_DATA,
    RESET_WIC_ADDRESS_DATA_SUCCESS,

    SAVE_WIC_SELECTED_ADDRESS_DATA,
    SAVE_WIC_SELECTED_ADDRESS_DATA_SUCCESS
);
